import { render, staticRenderFns } from "./UserEditTabAspiration.vue?vue&type=template&id=f9291f46&"
import script from "./UserEditTabAspiration.vue?vue&type=script&lang=js&"
export * from "./UserEditTabAspiration.vue?vue&type=script&lang=js&"
import style0 from "./UserEditTabAspiration.vue?vue&type=style&index=0&id=f9291f46&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports